import "../style/Contacto.css";
import neri from '../img/integrantes/neri.jpg';
import ml from '../img/integrantes/ml.jpg';
import sf from '../img/integrantes/sf.jpg';
import lg from '../img/integrantes/lg.jpg';



export default function Contacto() {
  return (
    <div className='container-contacto'>
      <h2 className="productos-titulo text-light text-center py-5 fw-bold">CONTACTO</h2>
     
    	<div className="container-fluid">
				<div className="row justify-content-center align-items-start g-2" >
					<div className="col">
						<h4>Encontramos en:</h4>
	      	  <i className="bi bi-telephone-fill"></i><p> 11-5588-4747</p>
	      	  <i class="bi bi-clock-fill"></i><p> Lunes a Sábados de 9 a 21hs</p>
	      	  <i className="bi bi-geo-alt-fill"></i><p>	Montes de Oca 2356 - CABA</p>
					</div>
					<div className="col contacto-mapa">
	      	  <iframe
	      	    title="map"
	      	    className="footer-iframe"
	      	    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.0392303583562!2d-58.37309602336411!3d-34.65371217293643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a334aab78be889%3A0xe808082ff7311cac!2sAv.%20Montes%20de%20Oca%202356%2C%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1693074691566!5m2!1sen!2sar"
	      	    allowfullscreen="" loading="lazy"
	      	    referrerpolicy="no-referrer-when-downgrade"></iframe>
					</div>
					<div className="col mb-2">
						<h4>Conocenos:</h4>
						{/* copiar esto */}
							<div className="d-block mb-2">
								<div className="btn-group me-2" role="group" aria-label="Neri Tisocco">
									<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src={neri} alt="Neri Tisocco" /><a href="https://n3ri.com.ar/" target="_blank" className="link-contacto">Neri Tisocco</a></button>
			  		  		<button type="button" className="btn btn-outline-secondary"><a href="https://linkedin.com/in/neritisocco/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
			  		  		<button type="button" className="btn btn-outline-secondary"><a href="https://github.com/N3RI/" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
  							</div>
							</div>
						{/* copiar esto */}
						<div className="d-block mb-2">
							<div className="btn-group me-2" role="group" aria-label="Emanuel Aragon">
								<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src='https://media.licdn.com/dms/image/D4D03AQGph0C5yRXKcg/profile-displayphoto-shrink_200_200/0/1702996258615?e=1708560000&v=beta&t=PcYcQiWBtUW0WIO9A6B072nlK_dtjx9cUE3ROj_HN7g' alt="Emanuel Aragon" />Emanuel Aragon</button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://linkedin.com/in/emanuel-aragon/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://github.com/AragonEA" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
							</div>
						</div>
						
                        <div className="d-block mb-2">
								<div className="btn-group me-2" role="group" aria-label="Cecilia Cruz">
									<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src='https://media.licdn.com/dms/image/D4E03AQG9cZdL-cQG8w/profile-displayphoto-shrink_800_800/0/1703001204044?e=1708560000&v=beta&t=9gYmUYYjcdN-ubQ6BDWMUNubJACXHWUG0p7ji35bETI' alt='Ceci Cruz'/>Cecilia Cruz</button>
			  		  		        <button type="button" className="btn btn-outline-secondary"><a href="www.linkedin.com/in/cecilia-cruz-guevara-024450239" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
			  		  		        <button type="button" className="btn btn-outline-secondary"><a href="https://github.com/cruzac1985" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
  							    </div>
					    </div>
						<div className="d-block mb-2">
								<div className="btn-group me-2" role="group" aria-label="Matias Lorenzo">
									<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src={ml} alt="Matias Lorenzo" /><a href="https://matiaslorenzo.ar/" target="_blank" className="link-contacto">Matias Lorenzo</a></button>
			  		  		<button type="button" className="btn btn-outline-secondary"><a href="https://linkedin.com/in/matias-lorenzo33/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
			  		  		<button type="button" className="btn btn-outline-secondary"><a href="https://github.com/melorenzo" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
  							</div>
						</div>
						<div className="d-block mb-2">
                            <div className="btn-group me-2" role="group" aria-label="Victoria Bruno">
                                <button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src='https://media.licdn.com/dms/image/D4D03AQG-3VnTUOt6Eg/profile-displayphoto-shrink_800_800/0/1688462931395?e=1708560000&v=beta&t=y5ktkNBbNywuwMGDDHyoY22jc_ouOsoLqLQ_CjPsI1s' alt="Victoria Bruno" />Victoria Bruno</button>
                                <button type="button" className="btn btn-outline-secondary"><a href="https://linkedin.com/in/pvictoriabruno/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
                                <button type="button" className="btn btn-outline-secondary"><a href="https://github.com/VickyBruno" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
                            </div>
                        </div>

						<div className="d-block mb-2">
							<div className="btn-group me-2" role="group" aria-label="Sandra Fabrizi">
								<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src={sf} alt="Sandra Fabrizi" />Sandra Fabrizi</button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://www.linkedin.com/in/sandra-fabrizi/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://github.com/sandra285" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
							</div>
						</div>

						<div className="d-block mb-2">
							<div className="btn-group me-2" role="group" aria-label="Leandro Gomez">
								<button type="button" className="btn btn-outline-secondary btn-ancho"><img className="rounded-circle me-1" width={25} height={25} src={lg} alt="Leandro Gomez" />Leandro Gómez</button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://www.linkedin.com/in/leandro-g%C3%B3mez/" target="_blank" className="link-contacto"><i class="bi bi-linkedin"></i></a></button>
								<button type="button" className="btn btn-outline-secondary"><a href="https://github.com/leogzar" target="_blank" className="link-contacto"><i class="bi bi-github"></i></a></button>
							</div>
						</div>


					</div>
				</div>
			</div>
		</div>
  )
}
